import styled from 'styled-components';


interface ButtonStyledProps {
    margin?: string;
    alignSelf?: string;
    isLoading?: boolean;
    disabled?: boolean;
}

export const ButtonStyled = styled.button<ButtonStyledProps>`
    background-color: #3978D7;
    color: #FFFFFF;
    width: ${({ id }) => id === 'botao-login' ? '151px' : 'max-content'};
    display: flex;
    align-items: center;
    border: none;
    border-radius: 28px;
    font-weight: 400;
    margin: ${({ margin }) => margin || ''};
    align-self: ${({ alignSelf }) => alignSelf || ''};

    ${({ className }) => className === 'with-icon' ?
        `
        height: 52px;
        padding: 14px 24px;
        gap: 20px;
        font-size: 20px;
        line-height: 20px;

        svg path {
            stroke: #FFF;
        }

        > .loader {
            margin-right: -1px;
        }
    `
        :
        `
        height: 40px;
        padding: 12px 24px;
        font-size: 16px;
        line-height: 16px;
     `
    }

    ${({ disabled }) => !disabled && `
        &:hover {
            box-shadow: 0 4px 8px 0 rgba(51, 55, 60, 0.16);
        }

    `}

    &:hover, &:active {
        background-color: #1670FA;
    }

    &:disabled {
        background-color: ${({ isLoading, className }) => (className === 'with-icon' && isLoading) ? '#3978D7' : '#E7EBF0'} !important;
        color: ${({ isLoading }) => isLoading ? '#FFF' : '#B3BAC3'};

        svg path {
            stroke: ${({ isLoading }) => isLoading ? '#FFF' : '#B3BAC3'} !important;
        }
    }
`;